(function() {
	'use strict';

	angular.module('quantixApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider', '$ocLazyLoadProvider' ];

	function stateConfig($stateProvider, $ocLazyLoadProvider) {

		$ocLazyLoadProvider
				.config({
					'debug' : false, /*
					 * for debugging ocLazyLoad module
					 * 'true/false'
					 */
					'events' : true, /*
					 * for event ocLazyLoad module
					 * 'true/false'
					 */
					'modules' : [
							{
								name : 'companyProfileLandingModule', /*
								 * injecting
								 * company profile landing
								 * for
								 * ocLazyLoad
								 */
								/* files for lazy load */
								files : [
										'app/company/companyProfile/companyProfile.controller.js',
										'app/services/companyProfile/companyProfile.service.js' ]
							},
							{
								name : 'companyProfileOutputModule', /*
								 * injecting
								 *  company profile output 
								 * for
								 * ocLazyLoad
								 */
								/* files for lazy load */
								files : [
										'app/company/companyProfile/companyDetails.controller.js',
										'app/services/companyProfile/companyProfile.service.js' ]
							},
							{
								name : 'ratingInformationModule', /*
								 * injecting
								 * rating information
								 * for
								 * ocLazyLoad
								 */
								/* files for lazy load */
								files : [
										'app/company/ratingInformation/ratingInformation.controller.js',
										'app/services/companyProfile/companyProfile.service.js' ]
							},
							{
								name : 'smeDetailsModule', /*
								 * injecting
								 * sme details
								 * Module for
								 * ocLazyLoad
								 */
								/* files for lazy load */
								files : [
										'app/company/smeInformation/smeDetails.controller.js',
										'app/services/companyProfile/companyProfile.service.js' ]
							},

							{
								name : 'scorecardDetailsModule', /*
								 * injecting
								 * score cards details
								 * Module
								 * for
								 * ocLazyLoad
								 */
								/* files for lazy load */
								files : [
										'app/company/companyProfile/scorecardCompanyProfile.controller.js',
										'app/services/companyProfile/companyProfile.service.js' ]
							},
							{
								name : 'ratingFeedModule', /*
								 * injecting
								 * rating feed
								 * Module for
								 * ocLazyLoad
								 */
								/* files for lazy load */
								files : [
										'app/company/ratingFeed/ratingFeed.controller.js',
										'app/services/ratingFeed/ratingFeed.service.js' ]
							}

					]
				});

		$stateProvider
				.state(
						'companyProfile',
						{
							parent : 'app',
							url : '/companyProfile',
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/company/companyProfile/companyProfile.html',
									controller : 'CompanyProfileController',
									controllerAs : 'vm'
								}
							},
							resolve : {
								loadMyCtrl : [
										'$ocLazyLoad',
										function($ocLazyLoad) {
											return $ocLazyLoad
													.load('companyProfileLandingModule'); /*
											 * Resolve
											 * promise
											 * and
											 * load
											 * before
											 * view
											 */
										} ],
							}
						})
				.state(
						'companyDetails',
						{
							parent : 'app',
							url : '/companyDetails',
							params : {
								companyCode : null,
								sectionId : null,
								companyCodeToview : null,
								companyName : null,
								flag : null
							},
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/company/companyProfile/companyDetails.html',
									controller : 'CompanyDetailsController',
									controllerAs : 'vm'
								}
							},
							resolve : {
								loadMyCtrl : [
										'$ocLazyLoad',
										function($ocLazyLoad) {
											return $ocLazyLoad
													.load('companyProfileOutputModule'); /*
											 * Resolve
											 * promise
											 * and
											 * load
											 * before
											 * view
											 */
										} ],
							}
						})
				.state(
						'smeDetails',
						{
							parent : 'app',
							url : '/smeDetails',
							params : {
								companyCode : null,
								flag : null
							},
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/company/smeInformation/smeDetails.html',
									controller : 'SmeDetailsController',
									controllerAs : 'vm'
								}
							},
							resolve : {
								loadMyCtrl : [
										'$ocLazyLoad',
										function($ocLazyLoad) {
											return $ocLazyLoad
													.load('smeDetailsModule'); /*
											 * Resolve
											 * promise
											 * and
											 * load
											 * before
											 * view
											 */
										} ],
							}
						})
				.state(
						'ratingInformation',
						{
							parent : 'app',
							url : '/ratingInformation',
							params : {
								companyCode : null,
								companyName : null
							},
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/company/ratingInformation/ratingInformation.html',
									controller : 'RatingInformationController',
									controllerAs : 'vm'
								}
							},
							resolve : {
								loadMyCtrl : [
										'$ocLazyLoad',
										function($ocLazyLoad) {
											return $ocLazyLoad
													.load('ratingInformationModule'); /*
											 * Resolve
											 * promise
											 * and
											 * load
											 * before
											 * view
											 */
										} ],
							}
						})
				.state(
						'scorecardDetails',
						{
							parent : 'app',
							url : '/scorecardDetails',
							params : {
								companyCode : null,
								companyName : null,
								scale : null,
								listedFlag : null
							},
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/company/companyProfile/scoreCardDetails.html',
									controller : 'CompanyScorecardController',
									controllerAs : 'vm'
								}
							},
							resolve : {
								loadMyCtrl : [
										'$ocLazyLoad',
										function($ocLazyLoad) {
											return $ocLazyLoad
													.load('scorecardDetailsModule'); /*
											 * Resolve
											 * promise
											 * and
											 * load
											 * before
											 * view
											 */
										} ],
							}
						})
				.state(
						'ratingFeed',
						{
							parent : 'app',
							url : '/ratingFeed',
							params : {
								companyCode : null,
								companyName : null,
								scale : null,
								listedFlag : null
							},
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/company/ratingFeed/ratingFeed.html',
									controller : 'RatingFeedController',
									controllerAs : 'vm'
								}
							},
							resolve : {
								loadMyCtrl : [
										'$ocLazyLoad',
										function($ocLazyLoad) {
											return $ocLazyLoad
													.load('ratingFeedModule'); /*
											 * Resolve
											 * promise
											 * and
											 * load
											 * before
											 * view
											 */
										} ],
							}
						});

	}
})();
